import GTVReferralsListPage from './GTVReferralsListPage';

export default GTVReferralsListPage;
